import * as React from "react";
import { Button } from "@material-ui/core";
import {
  Add as IconAdd,
  Remove as IconRemove,
} from "@material-ui/icons";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import "./index.scss";

interface Props {
  quantity: number;
  setQuantity: React.Dispatch<React.SetStateAction<number>>;
  onAdd: () => void;
  tableFinished: boolean
}

const MenuItemFooter: React.FC<Props> = ({
  quantity,
  setQuantity,
  onAdd,
  tableFinished
}) => {
  if(!!tableFinished) return null;
  return (
    <div className="bottom-fixed-row menu-item-qty-row">
      <div className="row qty-container">
        <div className="col-6 qty-action-quantity">
          <Button
            disabled={quantity <= 1}
            onClick={() => setQuantity((q) => q - 1)}
            className={`qty-action-button ${quantity === 1 ? 'disabled' : ''}`}
          >
            <IconRemove className="qty-action-button-icon" htmlColor={"#ffffff"}/>
          </Button>

          <span className="qty-label">{quantity}</span>

          <Button
            onClick={() => setQuantity((q) => q + 1)}
            className="qty-action-button"
          >
            <IconAdd className="qty-action-button-icon" htmlColor={"#ffffff"}/>
          </Button>
        </div>

        <div className="col-6">
          <Button
            className="accent-button qty-add-action-button"
            onClick={onAdd}
          >
            {LocalizerHelper.localized("add")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MenuItemFooter;
